export const BASE_URL = process.env.NODE_ENV === 'development'
    ? 'http://164.90.206.39:8081/api/'
    : 'https://medinakas.kg/api/'
